import {createContext, useEffect, useMemo, useState} from 'react'
import {get, getSelection, save} from './Database';

/**
20230629:: Choosing useContext over Redux to ensure that a junior programmer is capable of picking up react easily and building greatness from here.
Apologies to lack of document format control... -yh 
*/

export const GlobalContext = createContext()

export const GlobalContextProvider = (props) => { 
  const {global} = props
  
  //Create New List
  const [dropDownOption, setDropDownOption] = useState(null)
  const handleDropDownOption = (value) => setDropDownOption(value)
  
  // Location 
  const [zipcode, setZipcode] = useState(43560)
  const [WBAN, setWBAN] = useState("725360")
  const [city, setCity] = useState("Toledo")
  const [state, setState] = useState("OH")
  const [position, setPosition] = useState([41.65, -83.53])
  const [elevation, setElevation] = useState(669)
  const [temperature, setTemperature] = useState([]) //drybulb temperature Degrees F
  const [radiance, setRadiance] = useState([]) //global horizontal radiance Wh/m^2
  const [illuminance, setIlluminance] = useState([]) //global horizontal illuminance Lux
  const [humidity, setHumidity] = useState([]) //relative humidity Percent
  const [windSpeed, setWindSpeed] = useState([])  //wind speed m/s
  const [cloudCover, setCloudCover] = useState([]) //Cloud Cover in percentage
  const [avgDailyTemp, setAvgDailyTemp] = useState([])
  const [coldestHour, setColdestHour] = useState([])
  
  const handleZipcodeLookup = (value) => setZipcode(value)
  const handleWBANLookup    = (value) => setWBAN(value)
  const handleCityLookup    = (value) => setCity(value)
  const handleStateLookup   = (value) => setState(value)
  const handlePosition      = (value) => setPosition(value)
  const handleElevation     = (value) => setElevation(value)
  const handleTemperature   = (value) => setTemperature(value)
  const handleRadiance      = (value) => setRadiance(value)
  const handleIlluminance   = (value) => setIlluminance(value)
  const handleHumidity      = (value) => setHumidity(value)
  const handleWindSpeed     = (value) => setWindSpeed(value)
  const handleCloudCover    = (value) => setCloudCover(value)
  const handleAvgDailyTemp  = (value) => setAvgDailyTemp(value)
  const handleColdestHour   = (value) => setColdestHour(value)

  /* Greenhouse: Structure, Materials, Model, AIr Infiltration & Energy Curtain  */
  // Structure 
  const [structure, setStructure] = useState({length: 100.00, width: 25, sideHeight: 9, roofHeight: 13, numberOfSpans: 1, roofShape: "", peaksPerSpan: 1, endWall1: 0, endWall2: 0, sideWall1: 0, sideWall2: 0})
  const [length, setLength] = useState(100.00)
  const [width, setWidth] = useState(25.00)
  const [sideHeight, setSideHeight] = useState(9.00)
  const [roofHeight, setRoofHeight] = useState(13.00)
  const [numberOfSpans, setNumberOfSpans] = useState(1)
  const [roofShape, setRoofShape] = useState("")
  const [peaksPerSpan, setPeaksPerSpan] = useState(1)
  const [endWall1, setEndWall1] = useState(0.00)
  const [endWall2, setEndWall2] = useState(0.00)
  const [sideWall1, setSideWall1] = useState(0.00)
  const [sideWall2, setSideWall2] = useState(0.00)

  //Is it a quonset? Arched Roof, no sides:
  const [quonset, setQuonset] = useState(false)
  
  // // Volumes
  const [houseVolume, setHouseVolume] = useState(22500)
  const [roofVolume, setRoofVolume] = useState(5000)
  const [volumeAboveCurtain, setVolumeAboveCurtain] = useState(0)

  // // Surface areas
  const [roofSurfaceArea, setRoofSurfaceArea] = useState(2724.9)
  const [energyCurtainSurfaceArea, setEnergyCurtainSurfaceArea] = useState(0)
  const [ew1SurfaceArea, setEw1SurfaceArea] = useState(225)
  const [ew2SurfaceArea, setEw2SurfaceArea] = useState(225)
  const [sw1SurfaceArea, setSw1SurfaceArea] = useState(900)
  const [sw2SurfaceArea, setSw2SurfaceArea] = useState(900)

  const [ew1KneewallSurfaceArea, setEW1KneewallSurfaceArea] = useState(0)
  const [ew2KneewallSurfaceArea, setEW2KneewallSurfaceArea] = useState(0)
  const [sw1KneewallSurfaceArea, setSw1KneewallSurfaceArea] = useState(0)
  const [sw2KneewallSurfaceArea, setSW2KneewallSurfaceArea] = useState(0)
  
  const handleLengthValue            = (value) => setLength(value)
  const handleWidthValue             = (value) => setWidth(value);
  const handleSideHeight             = (value) => setSideHeight(value)
  const handleRoofHeight             = (value) => setRoofHeight(value);
  const handleNumberOfSpans          = (value) => setNumberOfSpans(value)
  const handleRoofShape              = (value) => setRoofShape(value)
  const handlePeaksPerSpan           = (value) => setPeaksPerSpan(value);
  const handleEndWall1               = (value) => setEndWall1(value)
  const handleEndWall2               = (value) => setEndWall2(value);
  const handleSideWall1              = (value) => setSideWall1(value)
  const handleSideWall2              = (value) => setSideWall2(value);
  const handleQuonset                = (bool)  => setQuonset(bool)
  const handleHouseVolume            = (value) => setHouseVolume(value) 
  const handleRoofVolume             = (value) => setRoofVolume(value)
  const handleVolumeAboveCurtain     = (value) => setVolumeAboveCurtain(value)
  const handleRoofSurfaceArea        = (value) => setRoofSurfaceArea(value)
  const handleECSurfaceArea          = (value) => setEnergyCurtainSurfaceArea(value)
  const handleEw1SurfaceArea         = (value) => setEw1SurfaceArea(value) 
  const handleEw2SurfaceArea         = (value) => setEw2SurfaceArea(value)
  const handleSw1SurfaceArea         = (value) => setSw1SurfaceArea(value)
  const handleSw2SurfaceArea         = (value) => setSw2SurfaceArea(value)
  const handleEW1KneewallSurfaceArea = (value) => setEW1KneewallSurfaceArea(value) 
  const handleEW2KneewallSurfaceArea = (value) => setEW2KneewallSurfaceArea(value)
  const handleSw1KneewallSurfaceArea = (value) => setSw1KneewallSurfaceArea(value)
  const handleSw2KneewallSurfaceArea = (value) => setSW2KneewallSurfaceArea(value)


  // Materials
  const [endWall1Type, setEndWall1Type] = useState("")
  const [endWall2Type, setEndWall2Type] = useState("")
  const [roofType, setRoofType] = useState("")
  const [sideWall1Type, setSideWall1Type] = useState("")
  const [sideWall2Type, setSideWall2Type] = useState("")
  const [endKneewall1Type, setEndKneewall1Type] = useState("")
  const [endKneewall2Type, setEndKneewall2Type] = useState("")
  const [sideKneewall1Type, setSideKneewall1Type] = useState("")
  const [sideKneewall2Type, setSideKneewall2Type] = useState("")

  const handleEndWall1Type      = (value) => setEndWall1Type(value)
  const handleEndWall2Type      = (value) => setEndWall2Type(value)
  const handleRoofType          = (value) => setRoofType(value)
  const handleSideWall1Type     = (value) => setSideWall1Type(value)
  const handleSideWall2Type     = (value) => setSideWall2Type(value)
  const handleEndKneewall1Type  = (value) => setEndKneewall1Type(value)
  const handleEndKneewall2Type  = (value) => setEndKneewall2Type(value)
  const handleSideKneewall1Type = (value) => setSideKneewall1Type(value)
  const handleSideKneewall2Type = (value) => setSideKneewall2Type(value)

  // Air Infiltration
  const [largeGap, setLargeGap] = useState("")
  const [smallGap, setSmallGap] = useState("")
  const [office, setOffice] = useState("")
  const [retailArea, setRetailArea] = useState("")
  const [shippingArea, setShippingArea] = useState("")
  const [headHouse, setHeadHouse] = useState("")
  const [currentAirInput, setCurrentAirInput] = useState(3.8)
  const [currentAirToggle, setCurrentAirToggle] = useState(true)
  const [malfunctioningToggle, setMalfunctioningToggle] = useState(false)
  const [gapsBetweenToggle, setGapsBetweenToggle] = useState(false)
  const [outsideIntakeToggle, setOutsideIntakeToggle] = useState(false)
  

  const handleLargeGap            = (value)  => setLargeGap(value)
  const handleSmallGap            = (value)  => setSmallGap(value)
  const handleOffice              = (value)  => setOffice(value)
  const handleRetailArea          = (value)  => setRetailArea(value)
  const handleShippingArea        = (value)  => setShippingArea(value)
  const handleHeadHouse           = (value)  => setHeadHouse(value)
  const handleCurrentAirInput     = (value)  => setCurrentAirInput(value)
  const handleCurrentAirToggle    = (toggle) => setCurrentAirToggle(toggle)
  const handleMalfunctiongToggle  = (toggle) => setMalfunctioningToggle(toggle)
  const handleGapBetweenToggle    = (toggle) => setGapsBetweenToggle(toggle)
  const handleOutsideIntakeToggle = (toggle) => setOutsideIntakeToggle(toggle)

  // Energy Curtain
  const [ecInstalled, setECInstalled] = useState(false)
  const [ecMaterialOption, setECMaterialOption] = useState("")
  const [qualityOption, setQualityOption] = useState("")
  const [conditionOption, setConditionOption] = useState("")
  const [currentECAirToggle, setCurrentECAirToggle] = useState(true)
  const [currentECAirInput, setCurrentECAirInput] = useState(4.4)
  const [currentUValueToggle, setCurrentUValveToggle] = useState(true)
  const [currentUValueInput, setCurrentUValveInput] = useState(0.68)

  // Set setComponent for Energy Curtain
  const handleECSwitch            = (installed) => setECInstalled(installed)
  const handleECMaterialOption    = (value) => setECMaterialOption(value)
  const handleQualityOption       = (value) => setQualityOption(value)
  const handleConditionOption     = (value) => setConditionOption(value)
  const handleCurrentECAirToggle  = (value) => setCurrentECAirToggle(value)
  const handleCurrentECAirInput   = (value) => setCurrentECAirInput(value)
  const handleCurrentUValueToggle = (value) => setCurrentUValveToggle(value)
  const handleCurrentUValueInput  = (value) => setCurrentUValveInput(value)

  //Heating
  //Schedule Setup
  const scheduleType = ['No Heating', 'Constant Temperature', 'Day and Night Temperatures', 'Hourly Temperatures']
  const [heatScheduleTypeOption, setHeatScheduleTypeOption] = useState("")
  const [startMonth, setStartMonth] = useState("January") 
  const [scheduleStartDay, setScheduleStartDay] = useState(1)
  const [stopMonth, setStopMonth] = useState("January")
  const [stopDay, setStopDay] = useState(1)
  const [constantTemp, setConstantTemp] = useState(65.0)
  const [dayTemp, setDayTemp] = useState(65.0)
  const [nightTemp, setNightTemp] = useState(55.0)
  const [startDay, setStartDay] = useState(5)
  const [startNight, setStartNight] = useState(5)
  const [isChecked, setIsChecked] = useState(true)
  const [hsHourlyTemp, setHSHourlyTemp] = useState({tmp12A: 55, tmp1A: 55, tmp2A: 55, tmp3A: 55, tmp4A: 55, tmp5A: 55, tmp6A: 55, tmp7A: 55, tmp8A: 55, tmp9A: 55, tmp10A: 55, tmp11A: 55, tmp12P: 55, tmp1P: 55, tmp2P: 55, tmp3P: 55, tmp4P: 55, tmp5P: 55, tmp6P: 55, tmp7P: 55, tmp8P: 55, tmp9P: 55, tmp10P: 55, tmp11P: 55 })

  
  const handleHeatScheduleTypeOptions = (value) => setHeatScheduleTypeOption(value)  
  const handleStartMonth              = (value) => setStartMonth (value) 
  const handleScheduleStartDay        = (value) => setScheduleStartDay(value)
  const handleStopMonth               = (value) => setStopMonth(value)
  const handleStopDay                 = (value) => setStopDay(value)    
  const handleConstantTemp            = (value) => setConstantTemp(value)   
  const handleDayTemp                 = (value) =>  setDayTemp(value) 
  const handleNightTemp               = (value) => setNightTemp(value)
  const handleStartDay                = (value) => setStartDay(value)
  const handleStartNight              = (value) => setStartNight(value)         
  const handleIsChecked               = (value) => setIsChecked(value)
  const handleHSHourlyTemp            = (value) => setHSHourlyTemp(value)

  
  //System Setup
  const HEATERAGE = ['New (1-2 Years)', 'Intermediate (3-5 Years)', 'Old (6+ Years)']
  const MAINTENANCESCHEDULE = ['Weekly-Monthly', 'Annually', 'Every few years', 'Never']
  const DMUNITHEATER  = ['Forced Air']
  const DMHOTH2OBOILER = ["Forced Air", "Heated Floors", "Hot Water Pipe", "Steam Pipes"]
  const DMSTEAMBOILER = ["Forced Air", "Heated Floors", "Steam Pipes"]
  const VARFORCEDAIR = ["Air Above Bench", "Air Below Bench", "Tubes - Above Bench", "Tubes - Below Bench"]
  const VARH2OSTEAMPIPES = ["Air Below Bench", "Perimeter", "Finned - Perimeter", "Finned - Below Bench"]
  const VARHEATEDFLOORS = ["Insulated", "Not Insulated"]
  
  const [heaterTypeOption, setHeaterTypeOption] = useState("")
  const [fuelTypeOptions, setFuelTypeOptions] = useState("") 
  const [fuelPrice, setFuelPrice] = useState(0)  
  const [localHeaterEfficiencyToggle, setLocalHeaterEfficiencyToggle] = useState(true)
  const [localHeaterEfficiencyInput, setLocalHeaterEfficiencyInput] = useState(78)
  const [ventilationOption, setVentilationOption] = useState("")   
  const [deliveryMethodOption, setDeliveryMethodOption] = useState("") 
  const [dmSelectionOption, setDMSelectionOption] = useState([])
  const [variationOptions, setVariationOptions] = useState("")  
  const [isFuelPriceChecked, setIsFuelPriceChecked] = useState(false)
  const [haOption, setHAOption] = useState("")
  const [msOption, setMSOption] = useState("")
  const [globalHeaterEfficiencyToggle, setGlobalHeaterEfficiencyToggle] = useState(true)
  const [globalHeaterEfficiencyInput, setGlobalHeaterEfficiencyInput] = useState(46)
  
  const handleHeaterTypeOption                    = (value) => setHeaterTypeOption(value)
  const handleFuelTypeOptions                     = (value) => setFuelTypeOptions(value)
  const handleFuelPrice                           = (value) =>  setFuelPrice(value)
  
  const handleLocalHeaterEfficiencyOverrideClick  = ()      => setLocalHeaterEfficiencyToggle(!localHeaterEfficiencyToggle)
  const handleLocalHeaterEfficiencyInput          = (value) => setLocalHeaterEfficiencyInput(value)
  
  const handleVentilationChange                   = (value) => setVentilationOption(value)
  const handleDeliveryMethodChange                = (value) => setDeliveryMethodOption(value)
  const handleDMSelectionOption                   = (value) => setDMSelectionOption(value)
  const handleVariationOptionsChange              = (value) => setVariationOptions(value)
  const handleIsFuelPriceChecked                  = ()      => setIsFuelPriceChecked(!isFuelPriceChecked)
  const handleHeaterAgeOption                     = (value) => setHAOption(value)
  const handleMSOption                            = (value) => setMSOption(value)
  const handleGlobalHeaterEfficiencyOverrideClick = ()      => setGlobalHeaterEfficiencyToggle(!globalHeaterEfficiencyToggle)
  const handleGlobalHeaterEfficiencyInput         = (value) => setGlobalHeaterEfficiencyInput(value)

   // Lighting
   const [scheduleTypeOption, setScheduleTypeOption] = useState("") //Header/Top Menu
   const [LUDropDown, setLUDropDown] = useState("") // Lighting Unit Dropdown
   const [beginTime, setBeginTime] = useState('06:00') // https://reactjsexample.com/simple-react-time-input-field/
   const [endTime, setEndTime] = useState('20:00')
   const [beginTime12HR, setBeginTime12HR] = useState()
   const [endTime12HR, setEndTime12HR] = useState()
   const [uValue, setUValue] = useState(0)
   const [cValue, setCValue] = useState(0)
 
 
   // Hourly Light Schedule
   const [toggle1, setToggle1] = useState(false)
   const [toggle2, setToggle2] = useState(false)
   const [toggle3, setToggle3] = useState(false)
   const [toggle4, setToggle4] = useState(false)
   const [toggle5, setToggle5] = useState(false)
   const [toggle6, setToggle6] = useState(false)
   const [toggle7, setToggle7] = useState(false)
   const [toggle8, setToggle8] = useState(false)
   const [toggle9, setToggle9] = useState(false)
   const [toggle10, setToggle10] = useState(false)
   const [toggle11, setToggle11] = useState(false)
   const [toggle12, setToggle12] = useState(false)
   const [toggle13, setToggle13] = useState(false)
   const [toggle14, setToggle14] = useState(false)
   const [toggle15, setToggle15] = useState(false)
   const [toggle16, setToggle16] = useState(false)
   const [toggle17, setToggle17] = useState(false)
   const [toggle18, setToggle18] = useState(false)
   const [toggle19, setToggle19] = useState(false)
   const [toggle20, setToggle20] = useState(false)
   const [toggle21, setToggle21] = useState(false)
   const [toggle22, setToggle22] = useState(false)
   const [toggle23, setToggle23] = useState(false)
   const [toggle24, setToggle24] = useState(false)
   const [hourlyThreshold1 ,setHourlyThreshold1] = useState(0)
   const [hourlyThreshold2 ,setHourlyThreshold2] = useState(0)
   const [hourlyThreshold3 ,setHourlyThreshold3] = useState(0)
   const [hourlyThreshold4 ,setHourlyThreshold4] = useState(0)
   const [hourlyThreshold5 ,setHourlyThreshold5] = useState(0)
   const [hourlyThreshold6 ,setHourlyThreshold6] = useState(0)
   const [hourlyThreshold7 ,setHourlyThreshold7] = useState(0)
   const [hourlyThreshold8 ,setHourlyThreshold8] = useState(0)
   const [hourlyThreshold9 ,setHourlyThreshold9] = useState(0)
   const [hourlyThreshold10 ,setHourlyThreshold10] = useState(0)
   const [hourlyThreshold11 ,setHourlyThreshold11] = useState(0)
   const [hourlyThreshold12 ,setHourlyThreshold12] = useState(0)
   const [hourlyThreshold13 ,setHourlyThreshold13] = useState(0) 
   const [hourlyThreshold14 ,setHourlyThreshold14] = useState(0)
   const [hourlyThreshold15 ,setHourlyThreshold15] = useState(0)
   const [hourlyThreshold16 ,setHourlyThreshold16] = useState(0)
   const [hourlyThreshold17 ,setHourlyThreshold17] = useState(0)
   const [hourlyThreshold18 ,setHourlyThreshold18] = useState(0)
   const [hourlyThreshold19 ,setHourlyThreshold19] = useState(0)
   const [hourlyThreshold20 ,setHourlyThreshold20] = useState(0)
   const [hourlyThreshold21 ,setHourlyThreshold21] = useState(0)
   const [hourlyThreshold22 ,setHourlyThreshold22] = useState(0)
   const [hourlyThreshold23 ,setHourlyThreshold23] = useState(0)
   const [hourlyThreshold24 ,setHourlyThreshold24] = useState(0)
 
   const handleScheduleTypeOption = (value) => setScheduleTypeOption(value)
   const handleLUDropDown = (value) => setLUDropDown(value)
   const handleBeginTimeChange = (value) =>  setBeginTime(value) 
   const handleEndTimeChange = (value) => setEndTime(value)
   const handleBeginTime12HR = (value) => setBeginTime12HR(value)
   const handleEndTime12HR = (value) => setEndTime12HR(value)
   const handleUValueChange = (value) =>   setUValue(value)
   const handleCValueChange = (value) => setCValue(value)
   const handleToggle1 = (bool) => setToggle1(bool)
   const handleToggle2 = (bool) => setToggle2(bool)
   const handleToggle3 = (bool) => setToggle3(bool)
   const handleToggle4 = (bool) => setToggle4(bool)
   const handleToggle5 = (bool) => setToggle5(bool)
   const handleToggle6 = (bool) => setToggle6(bool)
   const handleToggle7 = (bool) => setToggle7(bool)
   const handleToggle8 = (bool) => setToggle8(bool)
   const handleToggle9 = (bool) => setToggle9(bool)
   const handleToggle10 = (bool) => setToggle10(bool)
   const handleToggle11 = (bool) => setToggle11(bool)
   const handleToggle12 = (bool) => setToggle12(bool)
   const handleToggle13 = (bool) => setToggle13(bool)
   const handleToggle14 = (bool) => setToggle14(bool)
   const handleToggle15 = (bool) => setToggle15(bool)
   const handleToggle16 = (bool) => setToggle16(bool)
   const handleToggle17 = (bool) => setToggle17(bool)
   const handleToggle18 = (bool) => setToggle18(bool)
   const handleToggle19 = (bool) => setToggle19(bool)
   const handleToggle20 = (bool) => setToggle20(bool)
   const handleToggle21 = (bool) => setToggle21(bool)
   const handleToggle22 = (bool) => setToggle22(bool)
   const handleToggle23 = (bool) => setToggle23(bool)
   const handleToggle24 = (bool) => setToggle24(bool)
   const handleHourlyThreshold1 = (value) => setHourlyThreshold1(value)
   const handleHourlyThreshold2 = (value) => setHourlyThreshold2(value)
   const handleHourlyThreshold3 = (value) => setHourlyThreshold3(value)
   const handleHourlyThreshold4 = (value) => setHourlyThreshold4(value)
   const handleHourlyThreshold5 = (value) => setHourlyThreshold5(value)
   const handleHourlyThreshold6 = (value) => setHourlyThreshold6(value)
   const handleHourlyThreshold7 = (value) => setHourlyThreshold7(value)
   const handleHourlyThreshold8 = (value) => setHourlyThreshold8(value)
   const handleHourlyThreshold9 = (value) => setHourlyThreshold9(value)
   const handleHourlyThreshold10 = (value) => setHourlyThreshold10(value)
   const handleHourlyThreshold11 = (value) => setHourlyThreshold11(value)
   const handleHourlyThreshold12 = (value) => setHourlyThreshold12(value)
   const handleHourlyThreshold13 = (value) => setHourlyThreshold13(value) 
   const handleHourlyThreshold14 = (value) => setHourlyThreshold14(value)
   const handleHourlyThreshold15 = (value) => setHourlyThreshold15(value)
   const handleHourlyThreshold16 = (value) => setHourlyThreshold16(value)
   const handleHourlyThreshold17 = (value) => setHourlyThreshold17(value)
   const handleHourlyThreshold18 = (value) => setHourlyThreshold18(value)
   const handleHourlyThreshold19 = (value) => setHourlyThreshold19(value)
   const handleHourlyThreshold20 = (value) => setHourlyThreshold20(value)
   const handleHourlyThreshold21 = (value) => setHourlyThreshold21(value)
   const handleHourlyThreshold22 = (value) => setHourlyThreshold22(value)
   const handleHourlyThreshold23 = (value) => setHourlyThreshold23(value)
   const handleHourlyThreshold24 = (value) => setHourlyThreshold24(value)
 
 // Lighting Setup
   const lightingUnit = ["Select One", "µmol /m² /s", "Footcandles", "Lux", "W/m² [PAR]", "W/m² [SW]"]
   const typeOfLights = ["High-Pressure Sodium", "Metal Halide", "Fluorescent", "Incandescent (100W)", "LED"]
   const [numberOfLights, setNumberOfLights] = useState(6)
   const [TOLDropDown, setTOLDropDown] = useState("High-Pressure Sodium")
   const [efficacy, setEfficacy] = useState("")
   const [wattageOfLights, setWattageOfLights] = useState(400)
   const [wattageOfBallasts, setWattageOfBallasts] = useState(55)
 
   const handleNumberOfLights = (value) => setNumberOfLights(value)
   const handleTOLDropDown = (value) => setTOLDropDown(value)
   const handleEfficacy = (value) => setEfficacy(value)
   const handleWattageOfLights = (value) => setWattageOfLights(value)
   const handleWattageOfBallasts = (value) => setWattageOfBallasts(value)
 
  // Plants
  const [viewSelection, setViewSelection] = useState([])

  const handleViewSelection = (value, option, type) => {
    if(type === 'reload') {
      getSelection(dropDownOption, data => setPlaceholder(data))
      setViewSelection(placeholder)
    } else if (type === 'clear') {
      setViewSelection([])
    } else {
        setViewSelection([...viewSelection, value])
    }    
  }

  const [flagged, setFlagged] = useState([])
  const handleFlagged = (value, type) => {
    if(type === 'reload') setFlagged(placeholder)
    else if (type === 'clear') setFlagged([])
    else setFlagged([...flagged, value])
  }

  const handleRemoveSelection = (value) => {

      const vsUpdate = viewSelection.filter((info) => value !== info.id )
      setViewSelection([...vsUpdate]) 
      
      const fUpdate = flagged.filter((item) => value !== item)
      setFlagged([...fUpdate])
      save({
        subMenu: global.component,
        viewSelection: viewSelection,
        flagged: flagged,
        listName: dropDownOption,
    })

  }  
  
      

   // IndexedDB
  const [db, setDB] = useState([])
  const handleGetDB = () => get(data => setDB({...db, data}))
  
  const [placeholder, setPlaceholder] = useState(null)
  const handlePlaceholder = (value) => setPlaceholder(value)
  
  const values = useMemo(() => [], [])
  useEffect(() => {if(db.data !== undefined) db.data.map((item) => values.push(item) )},[db.data, values])

   //Handles data autopopulation of previous sessions
  useEffect(() => {
    get(data => handleGetDB({...db, data}))

    //maybe a useReducer would better handle this situation?
    if(values) {
      // use subMenu to differentiate the data otherwise we may have some trouble ahead.
      values.map((item) =>  item.subMenu === 'Greenhouse' ? item.listName === dropDownOption &&
        [
          handleLengthValue(item.length),
          handleWidthValue(item.width),
          handleSideHeight(item.sideHeight),
          handleRoofHeight(item.roofHeight),
          handleNumberOfSpans(item.numberOfSpans),
          handleRoofShape(item.roofShape),
          handlePeaksPerSpan(item.peaksPerSpan),
          handleEndWall1(item.endWall1),
          handleEndWall2(item.endWall2),
          handleSideWall1(item.sideWall1),
          handleSideWall2(item.sideWall2),
          handleEndWall1Type(item.endWall1Type),
          handleEndWall2Type(item.endWall2Type),
          handleRoofType(item.roofType),
          handleSideWall1Type(item.sideWall1Type),
          handleSideWall2Type(item.sideWall2Type),
          handleEndKneewall1Type(item.endKneewall1Type),
          handleEndKneewall2Type(item.endKneewall2Type),
          handleSideKneewall1Type(item.sideKneewall1Type),
          handleSideKneewall2Type(item.sideKneewall2Type),
          handleLargeGap(item.largeGap),
          handleSmallGap(item.smallGap),
          handleOffice(item.office),
          handleRetailArea(item.retailArea),
          handleShippingArea(item.shippingArea),
          handleHeadHouse(item.headHouse),
          handleCurrentAirInput(item.currentAirInput),
          handleCurrentAirToggle(item.currentAirToggle),
          handleMalfunctiongToggle(item.malfunctioningToggle),
          handleGapBetweenToggle(item.gapsBetweenToggle),
          handleOutsideIntakeToggle(item.outsideIntakeToggle),
          handleECSwitch(item.ecInstalled),
          handleECMaterialOption(item.ecMaterialOption),
          handleQualityOption(item.qualityOption),
          handleConditionOption(item.conditionOption),
          handleCurrentECAirInput(item.currentECAirInput),
          handleCurrentECAirToggle(item.currentECAirToggle),
          handleCurrentUValueToggle(item.currentUValueToggle),
          handleCurrentUValueInput(item.currentUValueInput),
          handleECSurfaceArea(item.energyCurtainSurfaceArea),
          handleRoofSurfaceArea(item.roofSurfaceArea),
          handleRoofVolume(item.roofVolume),
          handleHouseVolume(item.houseVolume),
          handleQuonset(item.quonset)
        ]

      : item.subMenu === 'hsetup' ? item.listName === dropDownOption &&
        [
          handleHeaterTypeOption(item.heaterTypeOption),
          handleFuelTypeOptions(item.fuelTypeOptions),
          handleFuelPrice(item.fuelPrice),
          handleLocalHeaterEfficiencyOverrideClick(item.localHeaterEfficiencyOverrideClick),
          handleLocalHeaterEfficiencyInput(item.localHeaterEfficiencyInput),
          handleVariationOptionsChange(item.ventilationOption),
          handleDeliveryMethodChange(item.deliveryMethodChange),
          handleDMSelectionOption(item.dmSelectionOption),
          handleVariationOptionsChange(item.variationOptions),
          handleIsFuelPriceChecked(item.isFuelPriceChecked),
          handleHeaterAgeOption(item.heaterAgeOptihandle),
          handleMSOption(item.mSOptihandle),
          handleGlobalHeaterEfficiencyOverrideClick(item.globalHeaterEfficiencyOverrideClick),
          handleGlobalHeaterEfficiencyInput(item.globalHeaterEfficiencyInput),
        ]

      : item.subMenu === 'hsched' ? item.listName === dropDownOption &&
        [
          handleHeatScheduleTypeOptions(item.heatScheduleTypeOption),
          handleStartMonth(item.startMonth),
          handleScheduleStartDay(item.scheduleStartDay),
          handleStopMonth(item.stopMonth),
          handleStopDay(item.stopDay),
          handleConstantTemp(item.constantTemp),
          handleDayTemp(item.dayTemp),
          handleNightTemp(item.nightTemp),
          handleStartDay(item.startDay),
          handleStartNight(item.startNight),
          handleIsChecked(item.isChecked),
          handleHSHourlyTemp(item.heatTemp),
        ]

      : item.subMenu === 'lightingSetup' ? item.listName === dropDownOption &&
        [
          handleLUDropDown(item.LUDropDown),
          handleNumberOfLights(item.numberOfLights),
          handleTOLDropDown(item.TOLDropDown),
          handleEfficacy(item.efficacy),
          handleWattageOfLights(item.wattageOfLights),
          handleWattageOfBallasts(item.wattageOfBallasts),
        ]
      : item.subMenu === 'lightingSchedule' ? item.listName === dropDownOption &&
        [
          handleScheduleTypeOption(item.scheduleTypeOption), 
          handleBeginTime12HR(item.beginTime), 
          handleEndTime12HR(item.endTime),
          handleTOLDropDown(item.TOLDropDown), 
          handleLUDropDown(item.LUDropDown), 
          handleCValueChange(item.cValue), 
          handleToggle1(item.toggle1),
          handleToggle2(item.toggle2),
          handleToggle3(item.toggle3),
          handleToggle4(item.toggle4),
          handleToggle5(item.toggle5),
          handleToggle6(item.toggle6),
          handleToggle7(item.toggle7),
          handleToggle8(item.toggle8),
          handleToggle9(item.toggle9),
          handleToggle10(item.toggle10),
          handleToggle11(item.toggle11),
          handleToggle12(item.toggle12),
          handleToggle13(item.toggle13),
          handleToggle14(item.toggle14),
          handleToggle15(item.toggle15),
          handleToggle16(item.toggle16),
          handleToggle17(item.toggle17),
          handleToggle18(item.toggle18),
          handleToggle19(item.toggle19),
          handleToggle20(item.toggle20),
          handleToggle21(item.toggle21),
          handleToggle22(item.toggle22),
          handleToggle23(item.toggle23),
          handleToggle24(item.toggle24),
          handleHourlyThreshold1(item.hourlyThreshold1),
          handleHourlyThreshold2(item.hourlyThreshold2),
          handleHourlyThreshold3(item.hourlyThreshold3),
          handleHourlyThreshold4(item.hourlyThreshold4),
          handleHourlyThreshold5(item.hourlyThreshold5),
          handleHourlyThreshold6(item.hourlyThreshold6),
          handleHourlyThreshold7(item.hourlyThreshold7),
          handleHourlyThreshold8(item.hourlyThreshold8),
          handleHourlyThreshold9(item.hourlyThreshold9),
          handleHourlyThreshold10(item.hourlyThreshold10),
          handleHourlyThreshold11(item.hourlyThreshold11),
          handleHourlyThreshold12(item.hourlyThreshold12),
          handleHourlyThreshold13(item.hourlyThreshold13),
          handleHourlyThreshold14(item.hourlyThreshold14),
          handleHourlyThreshold15(item.hourlyThreshold15),
          handleHourlyThreshold16(item.hourlyThreshold16),
          handleHourlyThreshold17(item.hourlyThreshold17),
          handleHourlyThreshold18(item.hourlyThreshold18),
          handleHourlyThreshold19(item.hourlyThreshold19),
          handleHourlyThreshold20(item.hourlyThreshold20),
          handleHourlyThreshold21(item.hourlyThreshold21),
          handleHourlyThreshold22(item.hourlyThreshold22),
          handleHourlyThreshold23(item.hourlyThreshold23),
          handleHourlyThreshold24(item.hourlyThreshold24)
        ]
      : item.subMenu === 'Plants' ? item.listName === dropDownOption &&
        [
          handleViewSelection(item.plantSelection),
          handleFlagged(item.flagged),
        ] 
          
      : null //here we leave everything the way it is
      )
    }
  },[dropDownOption])

  //we put everything together.
  const context = {global: global, placeholder:placeholder, onPlaceholder:handlePlaceholder, db: db, onGetDB: handleGetDB, dropDownOption:dropDownOption, onDropDownOption: handleDropDownOption, zipcode: zipcode, WBAN: WBAN, city: city, state: state, position: position, elevation: elevation, temperature: temperature, radiance: radiance, illuminance: illuminance, humidity: humidity, windSpeed: windSpeed, cloudCover: cloudCover, avgDailyTemp: avgDailyTemp, coldestHour: coldestHour, onZipcodeLookup: handleZipcodeLookup, onWBAN: handleWBANLookup, onCityLookup: handleCityLookup, onStateLookup: handleStateLookup, onPosition: handlePosition, onElevation: handleElevation, onTemperature: handleTemperature, onRadiance: handleRadiance, onIlluminance: handleIlluminance, onHumidity: handleHumidity, onWindSpeed: handleWindSpeed, onCloudCover: handleCloudCover, onAvgDailyTemp: handleAvgDailyTemp, onColdestHour: handleColdestHour, structure: structure, length: length,  width: width, sideHeight: sideHeight, roofHeight: roofHeight, numberOfSpans: numberOfSpans, roofShape: roofShape, peaksPerSpan: peaksPerSpan, endWall1: endWall1, endWall2: endWall2, sideWall1: sideWall1, sideWall2: sideWall2, quonset: quonset, houseVolume: houseVolume, roofVolume: roofVolume, volumeAboveCurtain: volumeAboveCurtain, roofSurfaceArea: roofSurfaceArea, energyCurtainSurfaceArea: energyCurtainSurfaceArea, ew1SurfaceArea: ew1SurfaceArea, ew2SurfaceArea: ew2SurfaceArea, sw1SurfaceArea: sw1SurfaceArea, sw2SurfaceArea: sw2SurfaceArea, ew1KneewallSurfaceArea: ew1KneewallSurfaceArea, ew2KneewallSurfaceArea: ew2KneewallSurfaceArea, sw1KneewallSurfaceArea: sw1KneewallSurfaceArea, sw2KneewallSurfaceArea: sw2KneewallSurfaceArea, endWall1Type:endWall1Type, endWall2Type: endWall2Type, roofType: roofType, sideWall1Type:sideWall1Type, sideWall2Type:sideWall2Type, endKneewall1Type:endKneewall1Type, endKneewall2Type:endKneewall2Type, sideKneewall1Type:sideKneewall1Type, sideKneewall2Type:sideKneewall2Type, largeGap:largeGap, smallGap:smallGap, office:office, retailArea:retailArea, shippingArea:shippingArea, headHouse:headHouse, currentAirInput:currentAirInput, currentAirToggle:currentAirToggle, malfunctioningToggle:malfunctioningToggle, gapsBetweenToggle:gapsBetweenToggle, outsideIntakeToggle:outsideIntakeToggle, ecInstalled:ecInstalled, ecMaterialOption:ecMaterialOption, qualityOption:qualityOption, conditionOption:conditionOption, currentECAirToggle:currentECAirToggle, currentECAirInput:currentECAirInput, currentUValueToggle:currentUValueToggle, currentUValueInput:currentUValueInput, onStructure: setStructure, onLengthValue: handleLengthValue, onWidthValue: handleWidthValue, onSideHeight: handleSideHeight, onRoofHeight: handleRoofHeight, onNumberofSpans: handleNumberOfSpans, onRoofShape: handleRoofShape, onPeaksPerSpan: handlePeaksPerSpan, onEndWall1: handleEndWall1, onEndWall2: handleEndWall2, onSideWall1: handleSideWall1, onSideWall2: handleSideWall2, onQuonset: handleQuonset, onHouseVolume: handleHouseVolume, onRoofVolume:handleRoofVolume, onVolumeAboveCurtain: handleVolumeAboveCurtain, onRoofSurfaceArea: handleRoofSurfaceArea, onECSurfaceArea: handleECSurfaceArea, onEw1SurfaceArea: handleEw1SurfaceArea, onEw2SurfaceArea:handleEw2SurfaceArea, onSw1SurfaceArea:handleSw1SurfaceArea, onSw2SurfaceArea:handleSw2SurfaceArea, onEW1KneewallSurfaceArea:handleEW1KneewallSurfaceArea, onEW2KneewallSurfaceArea:handleEW2KneewallSurfaceArea, onSw1KneewallSurfaceArea:handleSw1KneewallSurfaceArea, onSW2KneewallSurfaceArea:handleSw2KneewallSurfaceArea, onEndWall1Type:handleEndWall1Type, onEndWall2Type:handleEndWall2Type, onRoofType:handleRoofType, onSideWall1Type:handleSideWall1Type, onSideWall2Type:handleSideWall2Type, onEndKneewall1Type:handleEndKneewall1Type, onEndKneewall2Type:handleEndKneewall2Type, onSideKneewall1Type:handleSideKneewall1Type, onSideKneewall2Type:handleSideKneewall2Type, onLargeGap:handleLargeGap, onSmallGap:handleSmallGap, onOffice:handleOffice, onRetailArea:handleRetailArea, onShippingArea:handleShippingArea, onHeadHouse:handleHeadHouse, onCurrentAirInput:handleCurrentAirInput, onCurrentAirToggle:handleCurrentAirToggle, onMalfunctiongToggle:handleMalfunctiongToggle, onGapBetweenToggle:handleGapBetweenToggle, onOutsideIntakeToggle:handleOutsideIntakeToggle, onECSwitch:handleECSwitch, onECMaterialOption:handleECMaterialOption, onQualityOption:handleQualityOption, onConditionOption:handleConditionOption, onCurrentECAirToggle:handleCurrentECAirToggle, onCurrentECAirInput:handleCurrentECAirInput, onCurrentUValueToggle:handleCurrentUValueToggle, onCurrentUValueInput:handleCurrentUValueInput, options: scheduleType,  heatScheduleTypeOption:heatScheduleTypeOption, startDate: startMonth, startMonth, scheduleStartDay: scheduleStartDay, stopMonth: stopMonth, stopDay: stopDay, constantTemp: constantTemp, dayTemp:dayTemp, nightTemp: nightTemp,  startDay: startDay, startNight: startNight, isChecked: isChecked, hsHourlyTemp: hsHourlyTemp, heaterAge:HEATERAGE, maintenanceSchedule: MAINTENANCESCHEDULE, dmUnitHeater:DMUNITHEATER, dmHotH2OBoiler:DMHOTH2OBOILER, dmSteamBoiler:DMSTEAMBOILER, varForcedAir:VARFORCEDAIR, varH2OSteamPipes:VARH2OSTEAMPIPES, varHeatedFloors:VARHEATEDFLOORS, heaterTypeOption:heaterTypeOption, fuelTypeOptions:fuelTypeOptions, fuelPrice: fuelPrice, localHeaterEfficiencyToggle:localHeaterEfficiencyToggle, localHeaterEfficiencyInput:localHeaterEfficiencyInput, ventilationOption:ventilationOption, deliveryMethodOption:deliveryMethodOption, dmSelectionOption:dmSelectionOption, variationOptions:variationOptions, isFuelPriceChecked:isFuelPriceChecked, haOption:haOption, msOption:msOption, globalHeaterEfficiencyToggle:globalHeaterEfficiencyToggle, globalHeaterEfficiencyInput:globalHeaterEfficiencyInput, onStartMonth: handleStartMonth, onScheduleStartDay: handleScheduleStartDay, onStopMonth: handleStopMonth, onStopDay: handleStopDay, onConstantTemp: handleConstantTemp,  onDayTemp: handleDayTemp, onNightTemp: handleNightTemp, onStartDay:handleStartDay, onStartNight: handleStartNight,  onIsChecked: handleIsChecked, onHeatScheduleTypeOptions:handleHeatScheduleTypeOptions, onHSHourlyTemp: handleHSHourlyTemp, onHeaterTypeOption:handleHeaterTypeOption, onFuelTypeOptions:handleFuelTypeOptions, onFuelPrice:handleFuelPrice, onLocalHeaterEfficiencyOverrideClick:handleLocalHeaterEfficiencyOverrideClick, onLocalHeaterEfficiencyInput:handleLocalHeaterEfficiencyInput, onVentilationChange:handleVentilationChange, onDeliveryMethodChange:handleDeliveryMethodChange, onDMSelectionOption:handleDMSelectionOption, onVariationOptionsChange:handleVariationOptionsChange, onIsFuelPriceChecked:handleIsFuelPriceChecked, onHeaterAgeOption:handleHeaterAgeOption, onMSOption:handleMSOption, onGlobalHeaterEfficiencyOverrideClick:handleGlobalHeaterEfficiencyOverrideClick, onGlobalHeaterEfficiencyInput:handleGlobalHeaterEfficiencyInput, viewSelection: viewSelection, flagged: flagged, onViewSelection: handleViewSelection, onFlagged:handleFlagged, onRemoveSelection: handleRemoveSelection,  LUDropDown: LUDropDown, scheduleTypeOption: scheduleTypeOption, beginTime:beginTime, endTime: endTime, changeBeginTimeTo12HR:beginTime12HR, changeEndTimeTo12HR: endTime12HR, uValue:uValue, cValue:cValue, toggle1: toggle1, toggle2: toggle2, toggle3: toggle3, toggle4: toggle4, toggle5: toggle5, toggle6: toggle6, toggle7: toggle7, toggle8: toggle8, toggle9: toggle9, toggle10: toggle10, toggle11: toggle11, toggle12: toggle12, toggle13: toggle13, toggle14: toggle14, toggle15: toggle15, toggle16: toggle16, toggle17: toggle17, toggle18: toggle18, toggle19: toggle19, toggle20: toggle20, toggle21: toggle21, toggle22: toggle22, toggle23: toggle23, toggle24: toggle24,    hourlyThreshold1:hourlyThreshold1, hourlyThreshold2:hourlyThreshold2, hourlyThreshold3:hourlyThreshold3, hourlyThreshold4:hourlyThreshold4, hourlyThreshold5:hourlyThreshold5, hourlyThreshold6:hourlyThreshold6, hourlyThreshold7:hourlyThreshold7, hourlyThreshold8:hourlyThreshold8, hourlyThreshold9:hourlyThreshold9, hourlyThreshold10:hourlyThreshold10, hourlyThreshold11:hourlyThreshold11, hourlyThreshold12:hourlyThreshold12, hourlyThreshold13:hourlyThreshold13,  hourlyThreshold14:hourlyThreshold14, hourlyThreshold15:hourlyThreshold15, hourlyThreshold16:hourlyThreshold16, hourlyThreshold17:hourlyThreshold17, hourlyThreshold18:hourlyThreshold18, hourlyThreshold19:hourlyThreshold19, hourlyThreshold20:hourlyThreshold20, hourlyThreshold21:hourlyThreshold21, hourlyThreshold22:hourlyThreshold22, hourlyThreshold23:hourlyThreshold23, hourlyThreshold24:hourlyThreshold24, lightingUnit: lightingUnit, typeOfLights: typeOfLights, numberOfLights:numberOfLights, TOLDropDown:TOLDropDown, efficacy:efficacy, wattageOfLights:wattageOfLights, wattageOfBallasts:wattageOfBallasts, onLUDropDown: handleLUDropDown, onScheduleTypeOption: handleScheduleTypeOption, onBeginTimeChange:handleBeginTimeChange, onEndTimeChange:handleEndTimeChange, onBeginTime12HR:handleBeginTime12HR, onEndTime12HR:handleEndTime12HR, onUValueChange:handleUValueChange, onCValueChange:handleCValueChange, onToggle1: handleToggle1, onToggle2 : handleToggle2, onToggle3 : handleToggle3, onToggle4 : handleToggle4, onToggle5 : handleToggle5, onToggle6 : handleToggle6, onToggle7 : handleToggle7, onToggle8 : handleToggle8, onToggle9 : handleToggle9, onToggle10 : handleToggle10, onToggle11 : handleToggle11, onToggle12 : handleToggle12, onToggle13 : handleToggle13, onToggle14 : handleToggle14, onToggle15 : handleToggle15, onToggle16 : handleToggle16, onToggle17 : handleToggle17, onToggle18 : handleToggle18, onToggle19 : handleToggle19, onToggle20 : handleToggle20, onToggle21 : handleToggle21, onToggle22 : handleToggle22, onToggle23 : handleToggle23, onToggle24 : handleToggle24, onHourlyThreshold1:handleHourlyThreshold1, onHourlyThreshold2:handleHourlyThreshold2, onHourlyThreshold3:handleHourlyThreshold3, onHourlyThreshold4:handleHourlyThreshold4, onHourlyThreshold5:handleHourlyThreshold5, onHourlyThreshold6:handleHourlyThreshold6, onHourlyThreshold7:handleHourlyThreshold7, onHourlyThreshold8:handleHourlyThreshold8, onHourlyThreshold9:handleHourlyThreshold9, onHourlyThreshold10:handleHourlyThreshold10, onHourlyThreshold11:handleHourlyThreshold11, onHourlyThreshold12:handleHourlyThreshold12, onHourlyThreshold13:handleHourlyThreshold13,  onHourlyThreshold14:handleHourlyThreshold14, onHourlyThreshold15:handleHourlyThreshold15, onHourlyThreshold16:handleHourlyThreshold16, onHourlyThreshold17:handleHourlyThreshold17, onHourlyThreshold18:handleHourlyThreshold18, onHourlyThreshold19:handleHourlyThreshold19, onHourlyThreshold20:handleHourlyThreshold20, onHourlyThreshold21:handleHourlyThreshold21, onHourlyThreshold22:handleHourlyThreshold22, onHourlyThreshold23:handleHourlyThreshold23, onHourlyThreshold24:handleHourlyThreshold24, onNumberOfLights:handleNumberOfLights, onTOLDropDown:handleTOLDropDown, onEfficacy:handleEfficacy, onWattageOfLights:handleWattageOfLights, onWattageOfBallasts:handleWattageOfBallasts,
  }

  return <>
      {/* 3. Returns value */}
      <GlobalContext.Provider value={context}>
          {props.children}
      </GlobalContext.Provider>
    </>
}
 
export default GlobalContextProvider;
